<template>
    <div class="block-with-checks d-md-none">
        <div class="container">
            <div class="row">
                <div class="col-4 d-flex align-items-center">
                    <div class="check-item">
                        <img src="../../../../img/icon/submit.svg" alt="">
                        <p class="minimum">156 Elbolag</p>
                    </div>

                </div>
                <div class="col-4 d-flex align-items-center">
                    <div class="check-item">
                        <img src="../../../../img/icon/submit.svg" alt="">
                        <p class="minimum">Prisgaranti</p>
                    </div>
                </div>
                <div class="col-4 d-flex align-items-center">
                    <div class="check-item">
                        <img src="../../../../img/icon/submit.svg" alt="">
                        <p class="minimum">Kostnadsfritt</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BlockWithChecks"
    }
</script>
